function importAll(r) {
  r.keys().forEach(r);
}
const req = require.context('./svg', false, /\.svg$/);
importAll(req);
